import React, { useEffect } from 'react';
import './AgriClinicalServices.css';
import {
  Database, Users, Globe, BarChart2, ShieldCheck,
  Smartphone, Layers, MapPin, TreeDeciduous, Repeat
} from 'lucide-react';

const AgriClinicalServices = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Highlights Data
  const highlights = [
    { icon: <Users />, text: "Supports Multiple Crops, Locations, and Users" },
    { icon: <Repeat />, text: "Covers 'Sapling to Sale' and 'Farm to Fork' Cycles" },
    { icon: <Users />, text: "Labour and Inputs Optimization" },
    { icon: <Database />, text: "Crop-wise Financial Reports & Analytics" },
    { icon: <TreeDeciduous />, text: "Tree Encoding and Asset Valuation" },
    { icon: <MapPin />, text: "Geo-mapping and Crop Scouting Solutions" },
    { icon: <Layers />, text: "Integration with Legacy Systems & IoT Devices" },
    { icon: <BarChart2 />, text: "Farm Analytics for Data Driven Decisions" },
    { icon: <Globe />, text: "Organizational Hierarchy Mapping" },
    { icon: <ShieldCheck />, text: "Operator / Tapper Performance Tracking" },
    { icon: <Smartphone />, text: "Accessible over Web, Mobile, and Tablet" },
  ];

  return (
    <div className="acs-premium-page">
      {/* Hero Section */}
      <section className="acs-hero">
        <div className="acs-hero-content">
          <span className="acs-hero-badge">Smart Agriculture</span>
          <h1 className="acs-hero-title">Clinical Services</h1>
          <p className="acs-hero-subtitle">
            Advanced farm management solutions tailored for efficiency, sustainability, and profitability.
          </p>
        </div>
      </section>

      <div className="acs-container">

        {/* Platform Feature Section */}
        <section className="acs-platform-section">
          <div className="acs-platform-visual">
            <img
              src="https://res.cloudinary.com/drevfgyks/image/upload/v1725004448/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/2005.i518.010..automated_smart_garden_design_concept_banners_ifwf0u.jpg"
              alt="Farm Management Platform"
            />
          </div>
          <div className="acs-platform-content">
            <h2 className="acs-section-heading">Advanced Management Platform</h2>
            <p className="acs-text">
              Amaravathi Naturo Tech provides the most comprehensive agriculture platform, supporting entire business processes for plantations of any size. We simplify on-farm activities, harvest planning, quality control, and finance, effectively driving higher profit margins.
            </p>
            <p className="acs-text">
              Our platform offers smart data insights via BI dashboards, tree-wise inventory tracking, and geo-tagging solutions. It Seamlessly integrates with legacy financial software and smart hardware devices to empower decision-making.
            </p>
          </div>
        </section>

        {/* Services Cards (Contract & Consultation) */}
        <div className="acs-services-row">

          {/* Contract Farming Card */}
          <div className="acs-service-card">
            <div
              className="acs-service-bg"
              style={{ backgroundImage: `url('https://res.cloudinary.com/drevfgyks/image/upload/v1725018118/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/business-agreement-shaking-hands-melon-plantation_brljhx.jpg')` }}
            ></div>
            <div className="acs-service-overlay">
              <h3 className="acs-card-title">Contract Farming</h3>
              <ul className="acs-card-list">
                <li>Organic & Commercial Farming</li>
                <li>Corporate Level Farming</li>
                <li>Custom Crop Management Plans</li>
                <li>Advanced Seed Selection</li>
                <li>Online Consultancy Services</li>
              </ul>
            </div>
          </div>

          {/* Consultation Services Card */}
          <div className="acs-service-card">
            <div
              className="acs-service-bg"
              style={{ backgroundImage: `url('https://res.cloudinary.com/drevfgyks/image/upload/v1725001274/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/two-indian-business-man-suits-sitting-office-cafe-looking-laptop_qih0wn.jpg')` }}
            ></div>
            <div className="acs-service-overlay">
              <h3 className="acs-card-title">Consultation Services</h3>
              <ul className="acs-card-list">
                <li>Soil Identification & Preparation</li>
                <li>Maintenance Scheduling</li>
                <li>Crop Production & Protection</li>
                <li>Harvest Planning</li>
                <li>Yield Optimization</li>
              </ul>
            </div>
          </div>

        </div>

        {/* Highlights Grid */}
        <section className="acs-highlights-section">
          <h2 className="acs-section-heading" style={{ textAlign: 'center', display: 'block' }}>Highlights of ANT Platform</h2>
          <div className="acs-highlights-grid">
            {highlights.map((item, index) => (
              <div key={index} className="acs-highlight-card">
                <div className="acs-icon-box">
                  {React.cloneElement(item.icon, { size: 24 })}
                </div>
                <span className="acs-highlight-text">{item.text}</span>
              </div>
            ))}
          </div>
        </section>

        <p className="acs-footer">Emerging Farmers Empowerment</p>
      </div>
    </div>
  );
};

export default AgriClinicalServices;
